<template>
  <Info>
    Your account is restricted to mobile access only.
  </Info>
</template>

<script>
export default {
  name: "MobileOnly",
  components: {
    Info: () => import("@/components/auth/Info"),
  },
};
</script>

<style scoped></style>
